<template>
	<div>
		<div v-html="news_content"></div>
	</div>
</template>

<script>
	import request from '../common/request.js'
	export default {
		data() {
			return {
				news: {},
				news_content : ""
			}
		},
		created() {
			this.getNewsList()
			// 获取新闻列表
			// request.uniRequest('/news/getNewsList')
			// 	.then(res => {
			// 		// console.log('成功了吗news', res)
			// 		// this.posters = res.data.filter(item => item.web_type == 0)
			// 		this.news = res.data
			// 		// console.log('新闻--------',this.news);
			// 		// console.log(this.$route.query);
			// 		content_arr =  this.news.filter(item => {
			// 			return item._id == this.$route.query.id
			// 		})
			// 		this.news_content = content_arr[0].news_content
					
			// 	}).catch(e => {})
				
				
				
		},
		methods: {
			async getNewsList() {
				let content_arr = []
				
				let res = await this.$Cloud.table(`lf_func_lefan_news`).get({ page: 0, pageSize: 1000 })
				
				console.log('获取新闻列表',res)
				
				const {code,data} = res
				if(code == 200) {
					this.news = data.filter(item=>item.is_check==2)
					
					content_arr =  this.news.filter(item => {
						return item._id == this.$route.query.id
					})
					this.news_content = content_arr[0].news_content
				}
			}
		}
	}
</script>

<style>
</style>
